var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"login"},[_c('div',{staticClass:"main"},[_c('img',{staticClass:"animate__animated animate__bounceOut",attrs:{"src":require("../assets/images/common/loading.gif"),"alt":"","width":"150"}}),_c('div',{staticClass:"text animate__animated animate__bounceOut"},[_vm._v("Loading...")])])])])
}]

export { render, staticRenderFns }